import { render, staticRenderFns } from "./ImpactPage.vue?vue&type=template&id=d4c6e1a4&scoped=true"
import script from "./ImpactPage.vue?vue&type=script&lang=js"
export * from "./ImpactPage.vue?vue&type=script&lang=js"
import style0 from "./ImpactPage.vue?vue&type=style&index=0&id=d4c6e1a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c6e1a4",
  null
  
)

export default component.exports